import React from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import { useTranslation } from '../hooks/useTranslation';

interface TranslationContentProps extends Options {
    path: string;
    options?: Record<string, unknown>;
}

const TranslationContent: React.FC<TranslationContentProps> = ({ path, options, ...props }) => {
    const { t } = useTranslation();
    return <ReactMarkdown {...props}>{t(path, options)}</ReactMarkdown>;
};
export default TranslationContent;
